// The OPA / SCT guide (31_OpaSctPage.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Three views',
  tabsB: 'OPA documents lists the documents, SCT summary reads the same data one row per SKU, and SCT vs actual compares each order\'s cycle time with what Daily Output says the line spent.',
  newT: 'Start a document',
  newB: 'New OPA opens an empty operation document. Fill in the header, the SKUs and the operation lines, then save.',
  importT: 'Import from Excel',
  importB: 'Pick an OPA workbook (.xlsx). The sheets are read first and nothing is saved until you confirm, so you can check them before they become documents.',
  searchT: 'Find a document',
  searchB: 'Type a style name or document number to narrow the list. Column headers also sort and filter; Clear removes every filter at once.',
  listT: 'The documents',
  listB: 'One row per OPA document. The Action column at the right is where you open, copy or delete a document.',
};
const ko = {
  tabsT: '세 가지 보기',
  tabsB: 'OPA 문서는 문서 목록, SCT 요약은 같은 데이터를 SKU별 한 행으로 보여 주며, SCT 대 실적은 주문별 사이클 타임을 Daily Output의 실제 라인 소요 시간과 비교합니다.',
  newT: '문서 만들기',
  newB: '새 OPA를 누르면 빈 공정 문서가 열립니다. 헤더, SKU, 공정 라인을 입력한 뒤 저장하세요.',
  importT: 'Excel에서 가져오기',
  importB: 'OPA 워크북(.xlsx)을 선택하세요. 시트를 먼저 읽기만 하고 확인하기 전에는 저장하지 않으므로, 문서가 되기 전에 내용을 확인할 수 있습니다.',
  searchT: '문서 찾기',
  searchB: '스타일명이나 문서 번호를 입력해 목록을 좁히세요. 열 머리글로 정렬·필터도 되고, 초기화를 누르면 모든 필터가 한 번에 해제됩니다.',
  listT: '문서 목록',
  listB: 'OPA 문서당 한 행입니다. 오른쪽 작업 열에서 문서를 열거나 복사하거나 삭제합니다.',
};
const vi = {
  tabsT: 'Ba chế độ xem',
  tabsB: 'Tài liệu OPA là danh sách phiếu, Tổng hợp SCT đọc cùng dữ liệu đó theo từng SKU, còn SCT so với thực tế so sánh cycle time của từng đơn với thời gian chuyền thực tế trong Daily Output.',
  newT: 'Tạo phiếu mới',
  newB: 'Bấm OPA mới để mở một phiếu công đoạn trống. Điền phần đầu phiếu, các SKU và các dòng công đoạn, rồi lưu lại.',
  importT: 'Nhập từ Excel',
  importB: 'Chọn file OPA (.xlsx). Hệ thống chỉ đọc các sheet trước và chưa lưu gì cho đến khi bạn xác nhận, nên bạn có thể kiểm tra lại trước khi thành phiếu.',
  searchT: 'Tìm phiếu',
  searchB: 'Gõ tên style hoặc số phiếu để thu hẹp danh sách. Tiêu đề cột cũng dùng để sắp xếp và lọc; nút Xóa lọc bỏ hết bộ lọc một lần.',
  listT: 'Danh sách phiếu',
  listB: 'Mỗi phiếu OPA một dòng. Cột Thao tác ở bên phải là nơi bạn mở, sao chép hoặc xóa phiếu.',
};
const zh = {
  tabsT: '三种视图',
  tabsB: 'OPA 文档是文档列表，SCT 汇总把同样的数据按 SKU 一行一条显示，SCT 与实际对比则把每个订单的 cycle time 与 Daily Output 记录的产线实际用时进行对比。',
  newT: '新建文档',
  newB: '点击“新建 OPA”会打开一份空白工序文档。填写表头、SKU 和工序行后保存。',
  importT: '从 Excel 导入',
  importB: '选择 OPA 工作簿（.xlsx）。系统先只读取各个工作表，确认之前不会保存任何内容，因此可以先核对再生成文档。',
  searchT: '查找文档',
  searchB: '输入款式名称或文档编号即可缩小列表。列标题也可以排序和筛选，点击“清除”一次清除所有筛选。',
  listT: '文档列表',
  listB: '每份 OPA 文档一行。右侧的“操作”列用于打开、复制或删除文档。',
};
const dictionary = { ns: 'tourOpaSct', en, ko, vi, zh };
export default dictionary;
